import React,{useContext,useEffect} from "react";
import StudentNav from '../Navbars/StudentNav'
import AdminNav from '../Navbars/AdminNav' 
import GuestNav from "../Navbars/GuestNav";
import { UserContext } from '../UserContext';
import Footer from '../Footer'
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import HandwritingImg from './ArtsCourseImages/ArtsPortal.png'
import Testimonials from '../Testimonials'
import TeacherNav from "../Navbars/TeacherNav";
import FeeStructure from "../components/FeeStructure";

const HandwritingCourse = ({selectedCourse}) => {
  
  const handleCourseSelect = (course) => {
    console.log("Selected Course in Home:", course);
    selectedCourse(course);
  };

 const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo,userInfo } = useContext(UserContext);   
 
    useEffect(() => {
      const fetchData = async () => {
       await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
          credentials: 'include',
        }).then(response => {
            console.log("Response:",response);
          response.json().then(userInfo => {
            console.log("userinfo:",userInfo);
            setUserInfo(userInfo);

            if(userInfo?.usertype)
            {
              const uType=userInfo?.usertype;
              setUserRole(uType);
            }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable
          console.log("Uname: ", uname);
          console.log("Avatar: ", avatar);

          })
          .catch(err=> console.log("Error in useeffect:",err))
        });
      }
      fetchData();
    }, [isAdmin, isTeacher, isStudent, isGuest]);
  const determineUserRole = (usertype) => {
        console.log("In home.js:",usertype)
        if(usertype === 'Student')
          return "Student";
        else if(usertype === 'Teacher')
          return "Teacher";
        else if(usertype === 'Admin')
          return "Admin";
        else
          return "guest";
  };
  
 const navigate=useNavigate();
  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    console.log("Calling setUserRole.")
    setUserRole(userRole);
  };

  function onLogout() {
      console.log("inside Onlogout.");
      fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
        credentials: 'include',
        method: 'POST',
      });
      setUserInfo(null);
      setUserRole('guest');
      navigate("/");
    }
      
      const username = userInfo?.username;
      const _avatar_ = userInfo?.avatar;
   
  return (
    <div >
      
     {/* Navbar */}
     {username && (
        <>
        {isAdmin && <AdminNav  username={username} avatar={_avatar_} onLogout={onLogout} />}
        {isTeacher && <TeacherNav  username={username} avatar={_avatar_} onLogout={onLogout}/>}
        {isStudent && <StudentNav  username={username} avatar={_avatar_} onLogout={onLogout} />}
      </>
        )}  
        {!username && (
          <>
          {isGuest && <GuestNav onLogin={onLogin} />}
          </>
        )}
  
    <div className="PhotoShopPortalBackground">
      <section className="section">
        <p className="PageHead" style={{ color: "#8b0194" }} >Calligraphy Course</p>
        <div className="PageDesc">
        <div style={{display:"flex"}}>
          <p style={{
                fontFamily: "KG Primary Whimsy,VanillaMilk,'DM Sans', sans-serif",
                color: "white",
                textAlign: "left",
                padding: "30px",
                fontSize: "22px",
                zIndex: 1,
                color: "#8b0194",
                width:"70%"
              }}>
          The art of Islamic calligraphy is a beautiful tradition that combines spiritual expression with artistic skill. Our Islamic Calligraphy Course introduces children to this sacred art form, teaching them to create elegant Arabic scripts while connecting with Islamic heritage. Through structured lessons and mindful practice, students will learn traditional techniques to produce stunning calligraphic pieces worthy of display.
          </p>
          <img style={{minWidth:"250px", maxWidth:"450px", height: "300px"}} src={HandwritingImg} alt="Handwriting Course"></img>
          </div>
          <div className="btn-row d-flex btn-row-resp btn-row-resp1">
            <div style={{ width: "auto", height: "50px" }}>
              <a className="btn-row-resp button btn-color-course" href="#course">
                Course Structure
              </a>
            </div>
            <div style={{ width: "auto", height: "50px" }}>
              <a className="btn-row-resp button btn-color-fee" href="#fee">
                Fee Structure
              </a>
            </div>
            <div style={{ width: "auto", height: "50px" }}>
              <a className="btn-row-resp button btn-color-Testimonal" href="#testimonal">
                Testimonals
              </a>
            </div>
            <div style={{ width: "auto", height: "50px" }}>
              <a className="btn-row-resp button btn-color-Faq" href="#Faq">
                Faqs
              </a>
            </div>
            <div style={{ width: "auto", height: "50px" }}>
              <a className="btn-row-resp button btn-color-registered" href="#">
                Get Registered
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="overlay"></div>
    </div>

    {/* Intro text */}
    <div className="scratch-background">
      <section className="section">
        <p className="PageHead" style={{ color: "#8b0194" }}>
        Why Handwriting Matters?
        </p>
        <div className="PageDesc">
          <p style={{
              color: "#8b0194",
              marginTop: "2vh",
              fontSize: "4vh",
              fontFamily: "sans serif",
            }}
          >
          Islamic calligraphy is more than beautiful writing - it's a spiritual practice that has adorned mosques and manuscripts for centuries. Our course helps children appreciate this sacred art while developing patience, focus, and artistic expression. Students will learn proper techniques for holding the qalam (reed pen), preparing ink, and forming each letter with precision and grace.
      <br /><br />
      The course follows traditional methods, beginning with basic strokes and progressing to complete verses. Our experienced instructors, trained in classical calligraphy styles, provide guidance to help each student develop their skills while understanding the cultural significance of this timeless art form.
      </p>
        </div>
      </section>
    </div>

    {/* Course Structure and Syllabus */}
    <section className="section course-structure" id="course">
      <p className="PageHead" style={{ color: "#8b0194" }}>
        Course Structure and Syllabus
      </p>
      <h4 className="H4_Heading" style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
        <b>Course Objectives</b>
      </h4>
      <ul style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
        <li>Develop proper pencil grip and writing posture</li>
        <li>Master formation of all lowercase and uppercase letters</li>
        <li>Improve consistency in letter size and spacing</li>
        <li>Enhance writing speed without sacrificing legibility</li>
        <li>Build confidence in written expression</li>
        <li>Develop fine motor skills and hand-eye coordination</li>
      </ul>

      <div>
        <p className='moduleSection'>
          Calligrapghy Course
        </p>
      </div>

      {/* Module one */}
      <div className="modules">
        {/* round box */}
        <div className="round-box">
          <p style={{ marginTop: "5vh", color: "#cff7d5" }}>
            {" "}
            Module
            <br />
            1
          </p>
        </div>
        {/* small boxes */}
        <div className="small-box" style={{ color: "#249935" }}>
          <p style={{ margin: "auto" }}>
            Lessons
            <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>12</p>
          </p>
          <div className="small-box sm-box">
            <p style={{ margin: "auto" }}>
              Activities
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>24+</p>
            </p>
          </div>
        </div>

        <div className="large-box" style={{ color: "#249935" }}>
          <p style={{ margin: "auto" }}>
            Fundamentals of Handwriting
            <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
              This module introduces proper writing posture and pencil grip. Students will practice basic strokes, lines, and curves before progressing to letter formation. The module covers all lowercase and uppercase letters through engaging exercises.
            </p>
          </p>
        </div>
      </div>

      

      {/* <h6 style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
        <b>What Students Will Achieve</b>
      </h6>

      <div className="activityImagesContainer">
        <div className="row justify-content-center">
          <div className="col-md-4 mx-3 text-center">
            <p style={{ color: "#8b0194" }}>Proper Letter Formation</p>
          </div>
          <div className="col-md-4 mx-3 text-center">
            <p style={{ color: "#8b0194" }}>Consistent Sizing</p>
          </div>
          <div className="col-md-4 mx-3 text-center">
            <p style={{ color: "#8b0194" }}>Improved Spacing</p>
          </div>
          <div className="col-md-4 mx-3 text-center">
            <p style={{ color: "#8b0194" }}>Better Writing Speed</p>
          </div>
          <div className="col-md-4 mx-3 text-center">
            <p style={{ color: "#8b0194" }}>Increased Confidence</p>
          </div>
        </div>
      </div> */}
    </section>

    {/* Fee Structure */}
    <FeeStructure subject="calligraphy"/>

    <Testimonials />

    {/* Faqs */}
<div style={{ maxWidth: "100%", backgroundColor: "#edffff" }} id="Faq">
  <MDBContainer className="mt-0" style={{ maxWidth: "180vh" }}>
    <MDBAccordion alwaysOpen initialActive={1}>
      <div className="text-center PageHead" style={{ color: "#8b0194" }}>
        FAQs
      </div>
      <MDBAccordionItem
        collapseId={1}
        headerTitle="Q: What is Islamic calligraphy and why is it important?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Islamic calligraphy is the artistic practice of beautiful writing, primarily of Arabic script, that has been used for centuries to transcribe the Quran and decorate mosques. It's important because it combines artistic expression with spiritual devotion, preserving our Islamic heritage while developing patience and focus in students.
        </span>
      </MDBAccordionItem>
      
      <MDBAccordionItem
        collapseId={2}
        headerTitle="Q: At what age can children start learning calligraphy?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Children can begin learning basic calligraphy skills from age 8-10, when they've developed sufficient fine motor control. We offer beginner courses for ages 10+ that introduce the art form gradually with age-appropriate materials and simplified techniques.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={3}
        headerTitle="Q: What materials are needed for the calligraphy course?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Beginners will need: a calligraphy pen (qalam), special calligraphy ink, practice paper, and a writing board. We provide a starter kit that includes all necessary materials, with guidance on how to properly prepare and maintain traditional calligraphy tools.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={4}
        headerTitle="Q: Which calligraphy styles will students learn?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Our course begins with the foundational Naskh style, the most readable script used in Quranic texts. As students progress, they'll be introduced to Thuluth for decorative purposes and Ruq'ah for everyday writing. Advanced students may explore more complex styles like Diwani and Kufic.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={5}
        headerTitle="Q: How is Islamic calligraphy different from regular handwriting?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Islamic calligraphy follows strict rules of proportion and form, with each letter having precise measurements. Unlike everyday writing, it's a meditative art form that emphasizes beauty, balance, and spiritual intention. Students learn to write with special tools at deliberate speeds to achieve perfect shapes.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={6}
        headerTitle="Q: Can left-handed students learn calligraphy?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Absolutely. While traditional calligraphy is designed for right-handed writers, our instructors adapt techniques for left-handed students. This includes adjusting paper angles, modifying pen holds, and teaching specific stroke methods to prevent smudging.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={7}
        headerTitle="Q: How long does it take to see progress in calligraphy?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Basic letter forms can be learned in 8-12 weeks with regular practice. Mastery requires years of dedicated study, but students typically create presentable work within their first 3-6 months. Progress depends on practice frequency - we recommend at least 30 minutes daily.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={8}
        headerTitle="Q: Is prior knowledge of Arabic required?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        No, the course focuses on letter forms rather than language comprehension. However, familiarity with the Arabic alphabet is helpful. We teach the artistic aspects first, allowing students to appreciate the beauty of the script while optionally learning its meaning.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={9}
        headerTitle="Q: What are the spiritual benefits of learning calligraphy?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Calligraphy teaches patience, discipline, and mindfulness - all important Islamic virtues. The meditative process of creating each stroke helps develop khushu' (humility and concentration). Many students find it deepens their connection to Quranic verses as they carefully reproduce sacred texts.
        </span>
      </MDBAccordionItem>

      <MDBAccordionItem
        collapseId={10}
        headerTitle="Q: Can calligraphy skills lead to future opportunities?"
      >
        <strong style={{color: "#8b0194"}}>A: </strong>
        <span style={{color: "#8b0194"}}>
        Yes! Skilled calligraphers are in demand for mosque decorations, Quran publications, Islamic art commissions, and teaching. Many professional calligraphers start by learning the fundamentals in courses like ours before specializing in specific styles or applications.
        </span>
      </MDBAccordionItem>
    </MDBAccordion>
  </MDBContainer>
</div>
    {/* Footer */}
    <Footer/>
  </div>
  )
}

export default HandwritingCourse